

























































import Vue from "vue";
import FactBtn from "../Utilities/FactBtn.vue";
export default Vue.extend({
  name: "ProjectHistory",
  data: () => ({
    modalVisible: false as boolean
  }),
  components: {
    FactBtn
  },
  methods: {}
});
